/**
 * 自定义埋点的数据上报到 Native 的通道
 * 目的是为了实现与Hybrid-Native的跨端埋点监控
 * 目前 Raptor 项目的 Native SDK 跟 JS SDK 数据没有打通(预计2020Q4打通)
 */
// tslint:disable:trailing-comma

import axios from 'axios';
import { env } from '../../context/env';

const RAPTOR_API_URL = '//catdot.dianping.com/broker-service/api/metric';
const NATIVE_APPID = 26;

/**
 * 上报到 Native 侧数据通道中
 * @param key 指标
 * @param value 值，默认为 1
 * @param tags 纬度
 */
export function sendToNativeMetric(
  key: string,
  value = 1,
  tags: any = {}
): void {
  const baseReportURL = `${RAPTOR_API_URL}?p=${NATIVE_APPID}&v=1&unionId=${
    env.getEnv().neoUniqueId
  }&data=`;
  const data = {
    kvs: {
      // 这里必须是数组
      [key]: [value],
    },
    tags: {
      appId: NATIVE_APPID,
      ...tags,
    },
    ts: Math.floor(Date.now() / 1000),
  };
  try {
    const url = `${baseReportURL}${encodeURIComponent(JSON.stringify(data))}`;
    axios.get(url);
  } catch (e) {
    console.log(e);
  }
}
